import { Alert, Tooltip } from '@efast_public/fjd-component-library';

interface emptyStateComponentProps {
  readonly msg: string;
}

export function EmptyStateComponent({
  msg
}: emptyStateComponentProps): JSX.Element {
  return (
    <Tooltip tooltip={msg}>
      <Alert data-testid={'emptyState'} variant="info" message={msg} />
    </Tooltip>
  );
}
